export default __webpack_public_path__ + "static/San-Francisco-42ab33c76646d705ab086c0384555ff2.svg";